/**
 * Challenge card – picks block, match row, and pick rows.
 * Composed by challengeCard.styles.ts.
 */

import type { Theme } from '../../theme/getTheme';
import { getChallengeCardMatchGridStyles } from './challengeCardMatchGrid.styles';
import { getChallengeCardPickCellsStyles } from './challengeCardPickCells.styles';

export function getChallengeCardMatchesStyles(theme: Theme): Record<string, object> {
  return {
    ...getChallengeCardMatchGridStyles(theme),
    ...getChallengeCardPickCellsStyles(theme),
  };
}
